export const ANSWER_CHOICE_VALUE_OTHER = "other";
